module.exports = __webpack_public_path__ + "static/media/new-new-scipy.6529861b.svg";